/**
 * Relates to anything on a search template for the most part
 */

export const dropdownSwitch = () => {
	const filter = document.querySelector(".search-taxonomy-filter");
	// if filter element exists
	if (filter) {
		filter.addEventListener("change", function () {
			this.form.submit();
		});
	}
};
